import { useState } from "react";
import { PostgresResponseForMedicalPaOrders } from "../../../../data-model/postgresResponseForMedicalPaOrders";

/** Represents the async state for medical PA orders data fetching. */
export interface MedicalPaOrdersState {
  data?: PostgresResponseForMedicalPaOrders;
  loading?: boolean;
  error?: string;
  /** Whether the inline (non-blocking) loader is active during next-page fetches. */
  showinLineLoader?: boolean;
}

/**
 * Provides local state for medical PA orders table data and its async lifecycle.
 *
 * @returns Table data array with setter, and orders state (data/loading/error) with setter
 */
export const useMedicalPaOrdersTableData = () => {
  const [tableData, setTableData] = useState<any[]>([]);
  const [medicalPaOrdersState, setMedicalPaOrdersState] =
    useState<MedicalPaOrdersState>({
      data: undefined,
      loading: false,
      error: undefined,
      showinLineLoader: false,
    });

  return {
    medicalPaOrdersState,
    setMedicalPaOrdersState,
    tableData,
    setTableData,
  };
};
